// extracted by mini-css-extract-plugin
module.exports = {"productOptions":"_3wX1D","variation":"_39GaW","configurableOptions":"_22fon","blockPrice":"_3F-Y_","blockButtons":"_3XWv1","blockOptions":"mcdhz"};